import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';

/**
 * Generic confirmation dialog. Pass `confirmWord` to require the user to type it before confirming.
 */
const ConfirmDialog = ({
  open,
  title,
  children,
  confirmLabel = 'Confirm',
  confirmColor = 'error',
  confirmWord,
  busy,
  onConfirm,
  onClose,
}) => {
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (open) {
      setTyped('');
    }
  }, [open]);

  const blocked = Boolean(confirmWord) && typed.trim().toUpperCase() !== confirmWord.toUpperCase();

  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {typeof children === 'string' ? <DialogContentText>{children}</DialogContentText> : children}
        {confirmWord && (
          <TextField
            autoFocus
            fullWidth
            size="small"
            sx={{ mt: 2 }}
            label={`Type ${confirmWord} to confirm`}
            value={typed}
            onChange={(event) => setTyped(event.target.value)}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button variant="contained" color={confirmColor} onClick={onConfirm} disabled={busy || blocked}>
          {busy ? <CircularProgress size={20} color="inherit" /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
